/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';

import { FormGeneralHelper } from '../../../helpers/FormGeneral';

import adescomStyle from 'assets/jss/adescom/adescomStyle';
import { provActions, provisionigConstants } from '../../../modules/provisioning/action';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import I18n from '../../../components/Translate/I18n';
import Table from '@material-ui/core/Table';
import { store } from '../../../core/store';
import { provisioningReducers } from '../../../modules/provisioning/reducers';

class ViewPlkGetList extends PureComponent {
    constructor(props) {
        super(props);

        store.injectReducer('provisioningReducers', provisioningReducers);
        this.state = {
            filter: [{ name: 'plusOrdersSetId', value: this.props.viewItem.id }],
            items: null,
        };
    }

    componentDidMount() {
        this.initial();
    }

    initial = () => {
        this.paginationCallbackFunction(FormGeneralHelper.getPath('/plus_orders_get_responses'), this.state.filter);
    };

    static getDerivedStateFromProps(props, state) {
        if (props.items && props.items !== state.items) {
            state.items = props.items;
        }
        return state;
    }

    paginationCallbackFunction = (url, filter) => {
        const { dispatch } = this.props;
        dispatch(provActions.getList(FormGeneralHelper.getByUri(url), filter, [{ name: 'id', value: 'DESC' }], provisionigConstants.PLK_LIST_VIEW));
    };

    render() {
        const { items } = this.state;
        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell padding="none" align="left">
                            <I18n trans="prov:list.id" />
                        </TableCell>
                        <TableCell padding="none" align="center">
                            <I18n trans="prov:list.operation" />
                        </TableCell>
                        <TableCell padding="none" align="center">
                            <I18n trans="prov:list.request_date" />
                        </TableCell>
                        <TableCell padding="none" align="right">
                            <I18n trans="prov:list.response_date" />
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items &&
                        items['hydra:member'] &&
                        items['hydra:member'].map((item) => {
                            return (
                                <TableRow key={'plk' + item.id}>
                                    <TableCell padding="none" align="left">
                                        {item.id}
                                    </TableCell>
                                    <TableCell padding="none" align="center">
                                        @todo
                                    </TableCell>
                                    <TableCell padding="none" align="center">
                                        {item.requestTime}
                                    </TableCell>
                                    <TableCell padding="none" align="right">
                                        {item.responseTime}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                </TableBody>
            </Table>
        );
    }
}

ViewPlkGetList.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    const { provisioningReducers } = state;
    if (provisioningReducers && provisioningReducers.items) {
        return {
            items: provisioningReducers.items,
            type: provisioningReducers.type,
        };
    }
    return {};
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(ViewPlkGetList);
export default Enhance;
